<template>
  <div class="page">
    <header class="hero">
      <img
        class="brand-image"
        src="https://res.cloudinary.com/petaomeuladocombr/image/upload/v1759406245/petaomeulado/defaultImages/m6fny6cp5uftdntu5c6x.png"
        alt="PetAoLado.com"
      />
      <h2>Seu Pet sempre ao Seu Lado!</h2>
      <p class="subtitle">
        Seja muito bem-vindo à primeira Social Pet Market do Brasil!
      </p>
    </header>

    <section class="links">
      <template v-for="link in links">
        <!-- Render as div if it has multiple store links -->
        <div v-if="link.stores" :key="link.id + '-div'" class="link-button card-div">
          <div class="link-content">
            <img :src="link.image" :alt="link.label" class="link-image" />
            <div class="text-group">
              <span class="label">{{ link.label }}</span>
              <span class="description">{{ link.description }}</span>
              <div class="store-badges">
                <a
                  v-for="store in link.stores"
                  :key="store.id"
                  :href="store.href"
                  target="_blank"
                  rel="noopener"
                  class="store-link"
                >
                  <img :src="store.image" :alt="store.label" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <!-- Render as a regular link otherwise -->
        <a
          v-else
          :key="link.id + '-link'"
          class="link-button"
          :href="link.href"
          target="_blank"
          rel="noopener"
        >
          <div class="link-content">
            <img :src="link.image" :alt="link.label" class="link-image" />
            <div class="text-group">
              <span class="label">{{ link.label }}</span>
              <span class="description">{{ link.description }}</span>
            </div>
          </div>
          <span aria-hidden="true" class="icon">↗</span>
        </a>
      </template>
    </section>

    <section class="social-links">
      <a
        v-for="social in socialLinks"
        :key="social.id"
        class="social-button"
        :href="social.href"
        target="_blank"
        rel="noopener"
        :aria-label="social.label"
      >
        <img :src="social.image" :alt="social.label" />
      </a>
    </section>

    <footer class="footer">
      <div class="footer-content">
        <span class="footer-brand">///PetAoLado.com</span>
        <span class="footer-copy"
          >Copyright 2025 © Todos os direitos reservados</span
        >
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      links: [
        {
          id: "app",
          label: "Baixe o App PetAoLado",
          description: "E tenha todo universo pet na palma da sua mão",
          image:
            "https://res.cloudinary.com/petaomeuladocombr/image/upload/v1772643645/petaomeulado/defaultImages/k1zvqsdwm3ahszacemwa.png",
          stores: [
            {
              id: "google-play",
              label: "Google Play",
              href: "https://play.google.com/store/apps/details?id=com.petaolado.swpet&hl=pt_BR",
              image: require("./assets/google.png"),
            },
            {
              id: "app-store",
              label: "App Store",
              href: "https://apps.apple.com/br/app/petaolado/id6760318162",
              image: require("./assets/apple.png"),
            },
          ],
        },
        {
          id: "primary",
          label: "Acesse nosso portal",
          description: "Conheça a primeira Social Pet Market do Brasil",
          href: "https://petaolado.com",
          image:
            "https://res.cloudinary.com/petaomeuladocombr/image/upload/v1756918268/petaomeulado/defaultImages/fmunmd2sqneadn949who.png",
        },
        {
          id: "secondary",
          label: "É lojista ou profissional?",
          description: "Crie já seu portal e se destaque agora mesmo!",
          href: "https://petaolado.com/onBoarding",
          image:
            "https://res.cloudinary.com/petaomeuladocombr/image/upload/v1756764218/petaomeulado/defaultImages/uzfsw6groeawwmujd1yr.png",
        },
        {
          id: "shopkeeperApp",
          label: "Já é nosso lojista?",
          description: "Baixe o app PetAoLado Lojista e gerencie seu portal!",
          image:
            "https://res.cloudinary.com/petaomeuladocombr/image/upload/v1756764218/petaomeulado/defaultImages/uzfsw6groeawwmujd1yr.png",
          stores: [
            {
              id: "google-play",
              label: "Google Play",
              href: "https://play.google.com/store/apps/details?id=com.petaolado.shopkeepers_app",
              image: require("./assets/google.png"),
            },
            {
              id: "app-store",
              label: "App Store",
              href: "https://apps.apple.com/br/app/petaolado-parceiros/id6767868260",
              image: require("./assets/apple.png"),
            },
          ],
        },
        {
          id: "support",
          label: "Fale com a gente",
          description: "A equipe PetaoLado está aqui para te ajudar.",
          href: "https://petaolado.com/contactUs",
          image:
            "https://res.cloudinary.com/petaomeuladocombr/image/upload/v1758485309/petaomeulado/defaultImages/caokjmrhvm90id5vqwws.png",
        },
        {
          id: "commertial",
          label: "Suporte Comercial",
          description: "Fale com um consultor agora (Seg-Sex 09h-18h)",
          href: "https://api.whatsapp.com/send/?phone=5511942687372&text&type=phone_number&app_absent=0",
          image:
            "https://res.cloudinary.com/petaomeuladocombr/image/upload/v1763479491/petaomeulado/defaultImages/zwxlmizyouvcwvgdmwmz.webp",
        },
      ],
      socialLinks: [
        {
          id: "instagram",
          label: "Instagram",
          href: "https://www.instagram.com/petaolado",
          image:
            "https://res.cloudinary.com/petaomeuladocombr/image/upload/v1763476150/petaomeulado/defaultImages/eesrto6t9jqpvc9tilm1.png",
        },
        {
          id: "facebook",
          label: "Facebook",
          href: "https://www.facebook.com/PetAoLado",
          image:
            "https://res.cloudinary.com/petaomeuladocombr/image/upload/v1763476343/petaomeulado/defaultImages/daswejw7stngitm8jn5r.png",
        },
        {
          id: "tiktok",
          label: "TikTok",
          href: "https://www.tiktok.com/@petaolado",
          image:
            "https://res.cloudinary.com/petaomeuladocombr/image/upload/v1763476505/petaomeulado/defaultImages/be3qw9xx21zaailwnivo.avif",
        },
        {
          id: "youtube",
          label: "YouTube",
          href: "https://www.youtube.com/@PetAoLado",
          image:
            "https://res.cloudinary.com/petaomeuladocombr/image/upload/v1763476611/petaomeulado/defaultImages/zricm7a6mdwqzxeugwcd.png",
        },
      ],
    };
  },
};
</script>

<style>
:root {
  font-size: 16px;
  font-family: "Inter", "Segoe UI", system-ui, -apple-system, BlinkMacSystemFont,
    "Helvetica Neue", sans-serif;
  color: #0f172a;
  background-color: #0b1120;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

body,
html {
  margin: 0;
  padding: 0;
}

.page {
  min-height: 100vh;
  padding: 2.5rem 1.25rem 3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background: radial-gradient(circle at top, #5484ba, transparent 55%),
    radial-gradient(circle at bottom, #11558c, transparent 60%), #0b1120;
  gap: 1.5rem;
  position: relative;
  overflow: hidden;
  isolation: isolate;
}

.page::before {
  content: "";
  position: absolute;
  width: 160%;
  height: 160%;
  top: -30%;
  left: -30%;
  background: radial-gradient(circle, #11558c, transparent 55%),
    radial-gradient(circle at 30% 70%, #9a1f27, transparent 45%),
    radial-gradient(circle at 70% 30%, #5484ba, transparent 45%);
  filter: blur(40px);
  animation: backgroundDrift 18s ease-in-out infinite alternate;
  z-index: 0;
}

.hero {
  max-width: 520px;
  text-align: center;
  margin-bottom: 1rem;
  color: #e2e8f0;
  position: relative;
  z-index: 1;
}

.brand-image {
  width: clamp(180px, 50vw, 280px);
  margin-bottom: 0.2rem;
}

.hero h1 {
  font-size: clamp(1.8rem, 5vw, 2.75rem);
  margin: 0 0 0.55rem;
  color: #f8fafc;
}

.hero h2 {
  font-size: clamp(1.4rem, 5vw, 2rem);
  margin: 0 0 0.25rem;
  color: #f8fafc;
  font-family: "Fredoka";
}

.subtitle {
  margin: 0 auto;
  color: #cbd5f5;
  line-height: 1.5;
}

.links {
  width: 100%;
  max-width: 520px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1rem;
  position: relative;
  z-index: 1;
}

.social-links {
  width: 100%;
  max-width: 520px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(64px, 1fr));
  gap: 0.75rem;
  justify-items: center;
  margin-bottom: 1.5rem;
  position: relative;
  z-index: 1;
}

.social-button {
  width: 68px;
  height: 68px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.25);
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 180ms ease, border-color 180ms ease,
    background 180ms ease;
  box-shadow: 0 10px 25px rgba(5, 10, 20, 0.35);
}

.social-button img {
  margin: 2px;
  width: 62px;
  height: 62px;
  border-radius: 50%;
  object-fit: contain;
}

.social-button:hover,
.social-button:focus-visible {
  transform: translateY(-4px) scale(1.02);
  border-color: rgba(255, 255, 255, 0.6);
  background: rgba(255, 255, 255, 0.15);
  outline: none;
}

.link-button,
.card-div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem 1.5rem;
  border-radius: 1.25rem;
  text-decoration: none;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.18);
  box-shadow: 0 15px 40px rgba(5, 10, 20, 0.45);
  transition: transform 180ms ease, border-color 180ms ease,
    background 180ms ease;
  position: relative;
  overflow: hidden;
  z-index: 0;
}

.link-button::after {
  content: "";
  position: absolute;
  inset: 1px;
  border-radius: inherit;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.24),
    rgba(255, 255, 255, 0.06)
  );
  backdrop-filter: blur(22px);
  -webkit-backdrop-filter: blur(22px);
  z-index: -1;
}

.link-content {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
  flex: 1;
}

.link-image {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  object-fit: contain;
  flex-shrink: 0;
  background: rgba(15, 23, 42, 0.4);
  padding: 2px;
  box-shadow: 0 5px 10px rgba(15, 23, 42, 0.35);
}

.text-group {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  flex: 1;
}

.link-button:hover,
.link-button:focus-visible {
  transform: translateY(-4px);
  border-color: rgba(255, 255, 255, 0.45);
  background: rgba(255, 255, 255, 0.06);
  outline: none;
}

.link-button:active {
  transform: translateY(-1px);
}

.label {
  font-weight: 600;
  color: #f8fafc;
  font-size: 1.05rem;
}

.description {
  color: #cbd5e1;
  font-size: 0.95rem;
  line-height: 1.4;
}

.icon {
  color: #a5b4fc;
  font-size: 1.25rem;
  flex-shrink: 0;
}

.store-badges {
  display: flex;
  gap: 0.05rem;
  margin-top: 0.3rem;
}

.store-link {
  transition: transform 150ms ease;
}

.store-link:hover {
  transform: scale(1.05);
}

.store-link img {
  height: 45px;
  width: auto;
  display: block;
}

@keyframes backgroundDrift {
  0% {
    transform: scale(1) rotate(0deg);
  }
  50% {
    transform: scale(1.05) rotate(8deg);
  }
  100% {
    transform: scale(0.98) rotate(-6deg);
  }
}

.footer {
  width: 100%;
  max-width: 520px;
  padding: 1.25rem 0;
  border-top: 1px solid rgba(148, 163, 184, 0.25);
  margin-top: auto;
  position: relative;
  z-index: 1;
}

.footer-content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  color: #cbd5e1;
  font-size: 0.9rem;
  letter-spacing: 0.01em;
}

.footer-brand {
  font-weight: 600;
  color: #f8fafc;
}

.footer-divider {
  width: 36px;
  height: 1px;
  background: rgba(148, 163, 184, 0.5);
}

.footer-copy {
  white-space: nowrap;
}

@media (max-width: 480px) {
  .page {
    padding: 2rem 1rem;
  }

  .link-button {
    flex-direction: row;
    align-items: center;
    gap: 1rem;
  }

  .footer-content {
    flex-direction: column;
    text-align: center;
  }

  .footer-copy {
    white-space: normal;
  }

  .link-content {
    width: 100%;
    align-items: flex-start;
  }

  .icon {
    align-self: center;
    margin-left: 0.25rem;
  }

  .social-links {
    gap: 0.65rem;
  }

  .social-button {
    width: 64px;
    height: 64px;
  }
}
</style>
